var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F1F0EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8392 25.5357C27.347 23.538 25.4094 21.9158 23.1803 20.7981C20.9513 19.6804 18.4923 19.098 15.9987 19.0972C13.5051 19.0964 11.0458 19.6772 8.81599 20.7934C6.58623 21.9097 4.64756 23.5307 3.15405 25.5275C4.63993 27.5345 6.5754 29.1654 8.80527 30.2894C11.0352 31.4135 13.4974 31.9994 15.9946 32.0002C18.4917 32.001 20.9543 31.4167 23.1849 30.2941C25.4155 29.1714 27.352 27.5418 28.8392 25.5357Z",
    fill: "#657B89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 17.0324C19.4205 17.0324 22.1935 14.2594 22.1935 10.8388C22.1935 7.41821 19.4205 4.64526 15.9999 4.64526C12.5793 4.64526 9.8064 7.41821 9.8064 10.8388C9.8064 14.2594 12.5793 17.0324 15.9999 17.0324Z",
    fill: "#657B89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImage);
export default __webpack_public_path__ + "static/media/profileImage.9d424be4a54aa2851874bc2e297ce0e6.svg";
export { ForwardRef as ReactComponent };